import React, { useMemo } from "react";
import { LoadingIcon } from "../../../../components";
import { UI_DATE_FORMAT } from "../../../../consts";
import dayjs from "dayjs";
import { Table } from "antd";

const AnalysisTable = ({
  dateHeaders,
  analysisDataSource,
  expandedKeys,
  onExpand,
  showMetricColumn,
}) => {
  const analysisColumns = useMemo(() => {
    const subsiteColumn = {
      title: "Subsite",
      dataIndex: "subsite",
      key: "subsite",
      render: (text, record) => {
        if (record.isLoading) {
          return (
            <div className="flex items-center">
              <span>
                {text} <LoadingIcon height="60px" />
              </span>
            </div>
          );
        }
        if (record.isParent || record.isSummary) {
          return (
            <div
              className="font-semibold text-primaryBlue text-nowrap mr-8"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          );
        }
        return (
          <span>
            <br />
            <div
              className="font-semibold text-nowrap mr-4 ml-8"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </span>
        );
      },
    };

    const metricColumn = {
      title: "Metrics",
      dataIndex: "detail",
      key: "detail",
      render: (text, record) => {
        if (record.isLoading) {
          return null;
        }
        return <div dangerouslySetInnerHTML={{ __html: text }} />;
      },
    };

    const dateCols = dateHeaders.map((dh, idx) => ({
      title: dayjs(dh).format(UI_DATE_FORMAT),
      dataIndex: `day${idx}`,
      key: `day${idx}`,
      render: (val, record) => {
        if (record.isLoading) return null;
        return <div dangerouslySetInnerHTML={{ __html: val }} />;
      },
    }));

    if (!showMetricColumn) {
      return [subsiteColumn, ...dateCols];
    }
    return [subsiteColumn, metricColumn, ...dateCols];
  }, [dateHeaders, showMetricColumn]);

  const analysisRowClassName = (record) => {
    let classes = "border-b border-gray-300";
    if (record.isParent) {
      classes += " border-t-2 border-gray-400 pt-2 ";
    }
    return classes;
  };

  return (
    <Table
      columns={analysisColumns}
      dataSource={analysisDataSource}
      bordered={false}
      pagination={false}
      rowClassName={analysisRowClassName}
      expandable={{
        expandedRowKeys: expandedKeys,
        onExpand,
        defaultExpandAllRows: true,
      }}
      className="my-custom-table-class"
      onRow={(record) => {
        if (record.isSummary) {
          return { style: { backgroundColor: "#FFE699" } };
        }
        return {};
      }}
    />
  );
};

export default AnalysisTable;
